/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { ClosedEnum } from "../types/enums.js";

/**
 * 加密模式（必须与加密时相同）：GCM/CBC/ECB/CTR/OFB/CFB
 */
export const PostTextAesDecryptAdvancedMode = {
  Gcm: "GCM",
  Cbc: "CBC",
  Ecb: "ECB",
  Ctr: "CTR",
  Ofb: "OFB",
  Cfb: "CFB",
} as const;
/**
 * 加密模式（必须与加密时相同）：GCM/CBC/ECB/CTR/OFB/CFB
 */
export type PostTextAesDecryptAdvancedMode = ClosedEnum<
  typeof PostTextAesDecryptAdvancedMode
>;

export const PostTextAesDecryptAdvancedMode$zodSchema = z.enum([
  "GCM",
  "CBC",
  "ECB",
  "CTR",
  "OFB",
  "CFB",
]).describe("加密模式（必须与加密时相同）：GCM/CBC/ECB/CTR/OFB/CFB");

/**
 * 填充方式（可选，必须与加密时相同）：PKCS7/ZERO/NONE。GCM模式默认为NONE
 */
export const PostTextAesDecryptAdvancedPadding = {
  Pkcs7: "PKCS7",
  Zero: "ZERO",
  None: "NONE",
} as const;
/**
 * 填充方式（可选，必须与加密时相同）：PKCS7/ZERO/NONE。GCM模式默认为NONE
 */
export type PostTextAesDecryptAdvancedPadding = ClosedEnum<
  typeof PostTextAesDecryptAdvancedPadding
>;

export const PostTextAesDecryptAdvancedPadding$zodSchema = z.enum([
  "PKCS7",
  "ZERO",
  "NONE",
]).describe(
  "填充方式（可选，必须与加密时相同）：PKCS7/ZERO/NONE。GCM模式默认为NONE",
);

/**
 * 包含解密配置的JSON对象
 */
export type PostTextAesDecryptAdvancedRequest = {
  text: string;
  key: string;
  mode: PostTextAesDecryptAdvancedMode;
  padding?: PostTextAesDecryptAdvancedPadding | undefined;
  iv?: string | undefined;
};

export const PostTextAesDecryptAdvancedRequest$zodSchema: z.ZodType<
  PostTextAesDecryptAdvancedRequest
> = z.object({
  iv: z.string().optional(),
  key: z.string(),
  mode: PostTextAesDecryptAdvancedMode$zodSchema,
  padding: PostTextAesDecryptAdvancedPadding$zodSchema.optional(),
  text: z.string(),
}).describe("包含解密配置的JSON对象");

/**
 * 无效的请求参数或解密失败
 */
export type PostTextAesDecryptAdvancedBadRequestResponseBody = {
  error?: string | undefined;
};

export const PostTextAesDecryptAdvancedBadRequestResponseBody$zodSchema:
  z.ZodType<PostTextAesDecryptAdvancedBadRequestResponseBody> = z.object({
    error: z.string().optional(),
  }).describe("无效的请求参数或解密失败");

/**
 * 解密成功，返回原始明文
 */
export type PostTextAesDecryptAdvancedResponseBody = {
  plaintext?: string | undefined;
};

export const PostTextAesDecryptAdvancedResponseBody$zodSchema: z.ZodType<
  PostTextAesDecryptAdvancedResponseBody
> = z.object({
  plaintext: z.string().optional(),
}).describe("解密成功，返回原始明文");

export type PostTextAesDecryptAdvancedResponse =
  | PostTextAesDecryptAdvancedResponseBody
  | PostTextAesDecryptAdvancedBadRequestResponseBody;

export const PostTextAesDecryptAdvancedResponse$zodSchema: z.ZodType<
  PostTextAesDecryptAdvancedResponse
> = z.union([
  z.lazy(() => PostTextAesDecryptAdvancedResponseBody$zodSchema),
  z.lazy(() => PostTextAesDecryptAdvancedBadRequestResponseBody$zodSchema),
]);
